import { render, staticRenderFns } from "./ChooseGold.vue?vue&type=template&id=227a876a&scoped=true"
import script from "./ChooseGold.vue?vue&type=script&lang=js"
export * from "./ChooseGold.vue?vue&type=script&lang=js"
import style0 from "./ChooseGold.vue?vue&type=style&index=0&id=227a876a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227a876a",
  null
  
)

export default component.exports